<template>
    <div>
        <Head :title="__(title)" />
        <div class="flex flex-wrap">
            <div class="max-w-full lg:w-3/5">
                <form @submit.prevent="update" class="bg-white rounded-md shadow overflow-hidden mr-2">
                    <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                        <!--Super Admin -->
                        <select-edit-input v-if="auth.user.role.slug !== 'customer'" placeholder="Buscar" :onInput="doFilter" :items="customers"
                                             v-model="form.user_id" :error="form.errors.user_id"
                                             class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Customer')"
                                           :value="ticket.user" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input>
                        
                        <select-edit-input placeholder="Buscar" :onInput="doFilterEquipament" :items="equipament"
                                             v-model="form.equipament_id" :error="form.errors.equipament_id"
                                             class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Equipament / Location')"
                                           :value="ticket.equipament_name" :editable="true">
                        </select-edit-input>
                        
                        <div class="assigned_user pr-6 pb-8 w-full lg:w-1/3 flex flex-col">
                            <div class="font-bold text-sm mb-1">{{ __('Customer') }} email </div>
                            <div class="font-light text-sm">{{ form.user_email }}</div>
                        </div>


                        <select-edit-input placeholder="Search priority" :items="priorities"
                                           v-model="form.priority_id" :error="form.errors.priority_id"
                                           class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Priority')"
                                           :value="selectedPriorityName" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input>

                        <select-input v-if="!(hidden_fields && hidden_fields.includes('department'))" 
                        v-model="form.department_id" 
                        :error="form.errors.department_id"
                        :readonly="(ticket.closed)"
                        :disabled="(ticket.closed)"    
                        :editable="user_access.ticket.update && !ticket.closed"
                        :onChange="loadCategories" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Department')" :required="true">
                            <option :value="null" />
                            <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
                        </select-input>
                        
                     
                       
                        <select-edit-input v-if="auth.user.role.slug !== 'customer'" placeholder="Buscar" :onInput="doFilterUsersExceptCustomer" :items="usersExceptCustomers"
                                            v-model="form.assigned_to" :error="form.errors.assigned_to"
                                            class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Assigned to')"
                                        :value="ticket.assigned_user" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input>
                    
                     
                        
                        <select-edit-input placeholder="Select status to change" :items="statuses"
                                           v-model="form.status_id" :error="form.errors.status_id"
                                           class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Status')"
                                           :value="ticket.status?ticket.status.name:'N/A'" :editable="auth.user.role.slug !== 'customer' && user_access.ticket.update && !ticket.closed">
                        </select-edit-input>

                        <select-edit-input v-if="!(hidden_fields && hidden_fields.includes('ticket_type'))" placeholder="Buscar" :items="types"
                                           v-model="form.type_id" :error="form.errors.type_id"
                                           class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Ticket type')"
                                           :value="ticket.type" :editable="user_access.ticket.update && !ticket.closed">
                        </select-edit-input>

                        <select-input
                                v-model="form.support_type_id"
                                :error="form.errors.support_type_id"
                                class="pb-8 pr-6 w-full lg:w-1/3"
                                :readonly="ticket.closed"
                                :disabled="ticket.closed"
                                label="Tipo de Soporte">
                            <option :value="null">-- Sin asignar --</option>
                            <option v-for="st in support_types" :key="st.id" :value="st.id">{{ st.name }}</option>
                        </select-input>

                        <select-input 
                                v-if="!(hidden_fields && hidden_fields.includes('category'))" 
                                v-model="form.category_id" 
                                :error="form.errors.category_id" 
                                class="pb-8 pr-6 w-full lg:w-1/3" 
                                :readonly="(ticket.closed)"
                                :disabled="(ticket.closed)"  
                                :label="__('Category')" 
                                :required="true"
                                :value="ticket.category" :editable="user_access.ticket.update && !ticket.closed">
                            <option :value="null" />
                            <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>
                        </select-input>

                        <select-input
                                v-model="form.classification_id"
                                :onChange="onClassificationChange"
                                :error="form.errors.classification_id"
                                class="pb-8 pr-6 w-full lg:w-1/3"
                                :readonly="(ticket.closed)"
                                :disabled="(ticket.closed)"
                                label="Clasificación"
                                :value="ticket.classification" :editable="user_access.ticket.update && !ticket.closed">
                            <option :value="null" />
                            <option v-for="c in classifications" :key="c.id" :value="c.id">{{ c.name }}</option>
                        </select-input>

                        <select-input
                                v-model="form.subclassification_id"
                                :onChange="onSubclassificationChange"
                                :error="form.errors.subclassification_id"
                                class="pb-8 pr-6 w-full lg:w-1/3"
                                :readonly="(ticket.closed)"
                                :disabled="(ticket.closed || !form.classification_id)"
                                label="Subclasificación"
                                :value="ticket.subclassification" :editable="user_access.ticket.update && !ticket.closed">
                            <option :value="null" />
                            <option v-for="s in filteredSubclassifications" :key="s.id" :value="s.id">{{ s.name }}</option>
                        </select-input>

                        <div class="assigned_user pr-6 pb-8 w-full lg:w-1/3 flex flex-col">
                            <div class="font-bold text-sm mb-1">{{ __('Created') }} </div>
                            <div class="font-light text-sm">{{ moment(ticket.created_at).locale('es').fromNow() }}</div>
                            <div class="font-light text-xs text-gray-400">{{ moment(ticket.created_at).format('DD/MM/YYYY HH:mm') }}</div>
                        </div>

                        <div class="assigned_user pr-6 pb-8 w-full lg:w-1/3 flex flex-col">
                            <div class="font-bold text-sm mb-1">{{ __('Updated') }} </div>
                            <div class="font-light text-sm">{{ moment(ticket.updated_at).locale('es').fromNow() }}</div>
                            <div class="font-light text-xs text-gray-400">{{ moment(ticket.updated_at).format('DD/MM/YYYY HH:mm') }}</div>
                        </div>

                        <text-edit-input :editable="user_access.ticket.update && !ticket.closed" v-model="form.subject" :value="ticket.subject" :error="form.errors.subject" class="pr-6 pb-8 w-full lg:w-2/3" :label="__('Subject')" />

                        <div class="assigned_user pr-6 pb-8 w-full lg:w-full flex flex-col">
                            <div class="w-25 flex gap-3">
                                <label class="form-label" >{{ __('Request Details') }}</label>
                                <icon v-if="!enableEditor && user_access.ticket.update && !ticket.closed" name="edit" @click="enableEditor=!enableEditor" class="w-4 h-4 mr-1 cursor-pointer" />
                            </div>
                            <div v-if="!enableEditor" class="font-light text-sm" v-html="ticket.details"></div>
                            <div v-if="enableEditor" class="w-25 flex items-center">
                                <ckeditor id="ticketDetails" :editor="editor" v-model="form.details" :config="editorConfig"></ckeditor>
                                <div class="w-4 h-4 cursor-pointer">
                                    <icon @click="enableEditor=false" name="close" class="w-4 h-4 ml-2 cursor-pointer" />
                                </div>
                            </div>
                        </div>


                        <!-- Super Admin Comment -->
                        <input ref="file" type="file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .zip" class="hidden" multiple="multiple" @change="fileInputChange" />
                        <div class="pr-6 pb-8 w-full lg:w-full flex-col">
                            <button v-if="!ticket.closed" type="button" class="btn flex justify-center items-center pb-3 border-0 pl-0" @click="fileBrowse">
                                <icon name="file" class="flex-shrink-0 h-5 fill-gray-400 pr-1" /> <strong>{{ __('Attach File') }}</strong>
                            </button>
                            <div v-if="attachments.length" class="flex items-center justify-between pr-6 pt-8 w-full" v-for="(file, fi) in attachments" :key="fi">
                                <div class="flex-1 pr-1">
                                    {{ file.name }} <span class="text-gray-500 text-xs">({{ getFileSize(file.size) }})</span> <a v-if="file.user" class="text-sm" :href="this.route('users.edit', file.user.id)">{{ file.user.first_name }} {{ file.user.last_name }}</a> at <span class="text-sm">{{ file.created_at }}</span>
                                </div>
                                <div class="a__buttons flex justify-end items-center ">
                                    <button v-if="isPreviewable(file)" type="button" class="btn flex items-center" @click="previewFile = file">
                                        Ver</button>
                                    <button type="button" class="btn flex items-center ml-3" @click="downloadAttachment(file)">
                                        {{ __('Download') }}</button>
                                    <button v-if="!ticket.closed" type="button" class="btn flex items-center ml-3" @click="removeAttachment(file, fi)">
                                        {{ __('Remove') }}</button>
                                </div>
                            </div>
                            <div v-if="form.files.length" class="flex items-center justify-between pr-6 pt-8 w-full lg:w-1/2" v-for="(file, fi) in form.files" :key="fi">
                                <div class="flex-1 pr-1">
                                    {{ file.name }} <span class="text-gray-500 text-xs">({{ getFileSize(file.size) }})</span>
                                </div>
                                <button v-if="ticket.status && !ticket.closed" type="button" class="btn flex justify-center items-center" @click="fileRemove(file, fi)">
                                    {{ __('Remove') }}</button>
                            </div>
                        </div>

                        <div class="pr-6 pb-8 w-full lg:w-1/3 flex items-center" v-if="ticket.status && ticket.closed && ticket.review">
                            <strong>{{ __('Rating') }}: </strong> &nbsp; {{ ticket.review.rating }}
                            <p>
                                {{ ticket.review.review }}
                            </p>
                        </div>

                        <div class="flex flex-col w-full" v-if="ticket.status && ticket.closed && !ticket.review && auth.user.role.slug === 'customer'">
                            <div class="assigned_user star__review pb-5 w-full lg:w-1/3 flex flex-col">
                                <div class="font-bold">{{ __('How do you rate this support service?') }} </div>
                                <div class="star-rating pt-5">
                                    <input type="radio" id="5-stars" name="rating" v-model="form.rating" value="5" />
                                    <label for="5-stars" class="star">&#9733;</label>
                                    <input type="radio" id="4-stars" name="rating" v-model="form.rating" value="4" />
                                    <label for="4-stars" class="star">&#9733;</label>
                                    <input type="radio" id="3-stars" name="rating" v-model="form.rating" value="3" />
                                    <label for="3-stars" class="star">&#9733;</label>
                                    <input type="radio" id="2-stars" name="rating" v-model="form.rating" value="2" />
                                    <label for="2-stars" class="star">&#9733;</label>
                                    <input type="radio" id="1-star" name="rating" v-model="form.rating" value="1" />
                                    <label for="1-star" class="star">&#9733;</label>
                                </div>
                            </div>
                            <textarea-input v-model="form.review" :error="form.errors.review" class="pr-6 pb-4 w-full lg:w-1/3" :label="__('Feedback')" />
                            <div v-if="(!ticket.closed)" class="flex lg:w-1/4 mb-4"><button class="btn-indigo" type="submit">{{ __('Submit') }}</button></div>
                        </div>
                    </div>
                    <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
                        <button v-if="user_access.ticket.delete" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
                            {{ __('Delete') }}</button>
                        <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Save') }}</loading-button>
                    </div>
                </form>
            </div>
            <div class="max-w-full lg:w-2/5">
                <div class="bg-white rounded-md shadow overflow-hidden ml-2 chat-area comment-box flex-1 flex flex-col">
                    <div class="flex-3">
                        <div class="chat-header flex flex-col pb-3">
                            <h3 class="text-xl">{{ __('Ticket discussion') }}</h3>
                            <p class="text-sm font-light">{{ __('Comment histories for this ticket will be available here.') }}</p>
                        </div>
                    </div>
                    <div class="messages flex-1 overflow-auto reverse__order">
                        <div v-for="(comment, index) in comments.slice().reverse()" :key="index" class="message mb-4 flex">
                            <div v-if="comment.user_id !== user.id" class="flex-2">
                                <div class="w-12 h-12 relative">
                                    <span class="w-12 h-12 rounded-full mx-auto user_icon" alt="chat-user" v-if="comment.user">{{ Array.from(comment.user.first_name)[0] }}</span>
                                </div>
                            </div>
                            <div v-if="comment.user_id !== user.id" class="flex-1 px-2">
                                <h3 class="font-bold pb-2 text-sm pt-1" v-if="comment.user">{{ comment.user.first_name }} {{ comment.user.last_name }}</h3>
                                <div class="inline-block bg-gray-300 user-comment-round p-2 px-4 text-gray-700 leading-5">
                                    <span class="font-bold text-[11px] text-black" v-if="comment.sendcustomer && auth.user.role.slug !== 'customer' && user_access.ticket.update">* Mensaje enviado al cliente * </span>
                                    <span class="text-[13px]" v-html="comment.details"></span>
                                </div>
                                <div class="pl-4"><small class="text-gray-500">{{ moment(comment.updated_at).fromNow(true) }}</small></div>
                            </div>

                            <div v-if="comment.user_id === user.id" class="flex-1 text-right">
                                 
                                <div class="inline-block bg-blue rounded p-1 px-4 text-white leading-5">
                                    <span class="font-bold text-[11px] text-white" v-if="comment.sendcustomer && auth.user.role.slug !== 'customer' && user_access.ticket.update">* Mensaje enviado al cliente * </span>
                                    <span class="text-[13px]"  v-html="comment.details"></span>
                                </div>
                                <div class="pr-4"><small class="text-gray-500">{{ moment(comment.updated_at).fromNow(true) }}</small></div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-2 pt-4 pb-3" v-if="(!ticket.closed)">
                        <div class="write bg-white p-5 shadow flex rounded-lg">
 
                            <!--  @keydown.enter.exact.prevent="submitComment" -->
                            <div class="flex-1" >
                                <ckeditor id="message" :editor="editor" v-model="comment" :config="editorConfigComment"></ckeditor>
                            </div>
                            <div class="flex-2 w-35 p-2 flex content-center items-center">
                                <div class="flex-1">
                                    <button v-if="(!ticket.closed)" class="bg-blue w-10 h-10 rounded-full flex justify-center items-center" @click="submitComment">
                                        <icon class="w-4 h-4 fill-gray-100" name="send"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-if="user.role.slug !== 'customer'" class="write bg-white  px-5 my-3 flex">
                            <label>
                                <input type="checkbox" value="1" v-model="sendcustomer">
                                {{ __('Send to response to client') }}
                            </label>
                             
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <file-preview-modal :file="previewFile" @close="previewFile = null" />
    </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextEditInput from '@/Shared/TextEditInput'
import SelectInput from '@/Shared/SelectInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import SelectEditInput from '@/Shared/SelectEditInput'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UploadAdapter from '@/Shared/UploadAdapter';
import FilePreviewModal from '@/Shared/FilePreviewModal'
import moment from 'moment'


export default {
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TextEditInput,
        TextareaInput,
        Link,
        Head,
        Icon,
        SelectInputFilter,
        SelectEditInput,
        FilePreviewModal,
    },
    layout: Layout,
    props: {
        title: String,
        ticket: Object,
        priorities: Array,
        statuses: Array,
        types: Array,
        support_types: Array,
        departments: Array,
        categories: Array,
        classifications: Array,
        subclassifications: Array,
        customers: Array,
        usersExceptCustomers: Array,
        attachments: Array,
        comments: Array,
        auth: Object,
        hidden_fields: Object,
        equipament : Object,
        users : Object,
        sendcustomer : Boolean,
    },
    remember: false,
    data() {
        
        return {
            user: this.$page.props.auth.user,
            type_status: [],
            comment: '',
            previewFile: null,
            editCustomer: false,
            enableEditor: false,
           // sendcustomer : false,
            user_access: this.$page.props.auth.user.access,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'insertTable', 'blockQuote', '|', 'imageUpload', 'mediaEmbed', '|', 'undo', 'redo' ],
                table: {
                    toolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
                },
                extraPlugins: [this.uploader],
            },
            editorConfigComment: {
                toolbar: [ 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', 'undo', 'redo' ],
                table: {
                    toolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
                },
                extraPlugins: [this.uploader],
            },
            form: this.$inertia.form({
                user_id : this.ticket.user_id,
                user_email : this.ticket.user_email,
                priority_id: this.ticket.priority_id,
                status_id: this.ticket.status_id,
                equipament_id: this.ticket.equipament_id,
                department_id: this.ticket.department_id,
                category_id: this.ticket.category_id,
                classification_id: this.ticket.classification_id,
                subclassification_id: this.ticket.subclassification_id,
                assigned_to: this.ticket.assigned_to,
                type_id: this.ticket.type_id,
                support_type_id: this.ticket.support_type_id,
                subject: this.ticket.subject,
                details: this.ticket.details,
                files: this.ticket.files,
                comments: this.ticket.comments,
                created_at: this.ticket.created_at,
                removedFiles: [],
                sendcustomer : this.sendcustomer,
                rating: 0,
                review: '',
            }),
        }
    },
    created() {
        if(this.auth.user.role.slug === 'customer' && this.statuses.length){
            this.type_status = this.statuses.filter(status=> (status.id === this.form.status_id) || status.name.match(/Close.*/))
        }else{
            this.type_status = this.statuses
        }
        this.moment = moment;
    },
    computed: {
        filteredSubclassifications() {
            if (!this.form.classification_id) return []
            return this.subclassifications.filter(s => s.classification_id === this.form.classification_id)
        },
        selectedPriorityName() {
            const p = this.priorities.find(p => p.id === this.form.priority_id)
            return p ? p.name : this.ticket.priority
        },
    },
    methods: {
        onClassificationChange() {
            this.form.subclassification_id = null
        },
        onSubclassificationChange(e) {
            const subId = e.target.value ? parseInt(e.target.value) : null
            const sub = this.subclassifications.find(s => s.id === subId)
            if (sub && sub.priority_id) {
                this.form.priority_id = sub.priority_id
            }
        },
        uploader(editor) {
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                return new UploadAdapter( loader );
            };
        },
        doFilter(e){
            this.axios.get(this.route('filter.customers', {search: e.target.value})).then((res)=>{
                this.customers.splice(0, this.customers.length, ...res.data);
            })
        }, 
        doFilterEquipament(e){
            this.axios.get(this.route('filter.lists.equipament', {search: e.target.value})).then((res)=>{
                this.equipament.splice(0, this.equipament.length, ...res.data);
            })
        },
        doFilterUsersExceptCustomer(e){
            this.axios.get(this.route('filter.users_except_customer', {search: e.target.value})).then((res)=>{
                this.usersExceptCustomers.splice(0, this.usersExceptCustomers.length, ...res.data);
            })
        },
        fileInputChange(e) {
            let selectedFiles = e.target.files;
            for (let i = 0; i < selectedFiles.length; i++) {
                this.form.files.push(selectedFiles[i]);
            }
        },
        fileRemove(image, index) {
            this.form.files.splice(index, 1);
        },
        fileBrowse() {
            this.$refs.file.click()
        },
        downloadAttachment(file) {
            const link = document.createElement("a");
            link.href = window.location.origin + '/files/' + file.path;
            link.download = file.name;
            link.click();
        },
        isPreviewable(file) {
            const ext = file.name.split('.').pop().toLowerCase()
            return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'pdf'].includes(ext)
        },
        removeAttachment(file, index) {
            this.attachments.splice(index, 1);
            this.form.removedFiles.push(file.id)
        },
        getFileSize(size) {
            const i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
        },
        uploadFiles() {
            this.form.files = this.$refs.files.files
        },
        update() {
            this.form.post(this.route('tickets.update', this.ticket.id))
            this.form.files = []
            this.form.comment = ''
            
        },
        destroy() {
            if (confirm('Are you sure you want to delete this ticket?')) {
                this.$inertia.delete(this.route('tickets.destroy', this.ticket.id))
            }
        },
        restore() {
            if (confirm('Are you sure you want to restore this ticket?')) {
                this.$inertia.put(this.route('tickets.restore', this.ticket.id))
            }
        },
        submitComment(){
            var that = this;
            const messageData = {
                comment: this.comment,
                sendcustomer: this.sendcustomer,
                user_id: this.user.id,
                _token: this.$page.props.csrf_token,
                ticket_id: this.ticket.id
            }
            if (this.comment){

                this.comment = ''
               

                this.axios.post(this.route('ticket.comment'), messageData).then((response) => {
                    if(response.data){
                        that.comments.push(response.data)
                    }
                     
                }).catch((error) => {
                    console.log(error)
                })
            } 
        },
        loadCategories(e){ 
            this.$inertia.get(this.route('tickets.edit', {uid : this.ticket.id ,  category_id: e.target.value}), {e}, {
                    preserveState: true,
                    preserveScroll: true,
                    replace: true
            })
            
        }
    },
}
</script>
